import Vue from 'vue';

export default {
    async timeLapseFunction() {
        const response = await Vue.axios.get('prikljucek/storitve/naborTvStoritev?idTehnoloskaOsnova=44');
        return response.data.casovniZamik;
    }
}